import cn from 'classnames';
import { forwardRef } from 'react';

import type { ForwardedRef, ReactElement } from 'react';

import type { ModalHeaderTitleProps } from './modal-header-title.types';

import './modal-header-title.scss';

/**
 * Modal header title is used to render the title in the header section of the modal dialog.
 */
const ModalHeaderTitle = forwardRef(
  (props: ModalHeaderTitleProps, forwardedRef: ForwardedRef<HTMLDivElement>): ReactElement => {
    const { children, className, ...rest } = props;

    return (
      <div {...rest} className={cn('rbui-modal__header-title', className)} ref={forwardedRef}>
        {children}
      </div>
    );
  },
);

ModalHeaderTitle.displayName = 'ModalHeaderTitle';

export default ModalHeaderTitle;
